import { gql } from "@apollo/client"

const STEP_FIELDS = gql`
  fragment StepFields on JobProcessStep {
    ... on CheckboxJobStep {
      id
      step
      name
      description
    }
    ... on DateTimeJobStep {
      id
      step
      name
      description
    }
    ... on FilesJobStep {
      id
      step
      name
      description
    }
    ... on InstructionJobStep {
      id
      step
      name
      description
    }
    ... on LongTextJobStep {
      id
      step
      name
      description
    }
    ... on MultipleChoiceJobStep {
      id
      step
      name
      description
    }
    ... on NumberJobStep {
      id
      step
      name
      description
    }
    ... on NumberRatingJobStep {
      id
      step
      name
      description
    }
    ... on PhotosJobStep {
      id
      step
      name
      description
    }
    ... on ProcessJobStep {
      id
      step
      name
      description
    }
    ... on SectionJobStep {
      id
      step
      name
      description
    }
    ... on SelectionJobStep {
      id
      step
      name
      description
    }
    ... on SignatureJobStep {
      id
      step
      name
      description
    }
    ... on TemperatureTimerJobStep {
      id
      step
      name
      description
    }
    ... on TextJobStep {
      id
      step
      name
      description
    }
  }
`

export { STEP_FIELDS }
